import { BumpSerie, BumpDatum } from '@nivo/bump';
import { Serie } from '@nivo/line';

export function formatBumpChartData(
  data: Serie[]
): BumpSerie<BumpDatum, Record<string, never>>[] {
  const valuesByDay: Record<string, { value: number; index: number }[]> = {};

  data.forEach((dataItem, index) => {
    dataItem.data.forEach(({ x, y }) => {
      if (valuesByDay[x as string] === undefined) {
        valuesByDay[x as string] = [];
      }

      valuesByDay[x as string].push({ index, value: y as number });
    });
  });

  Object.keys(valuesByDay).forEach((day, dayIndex) => {
    const valuesArr = valuesByDay[day];

    valuesArr.sort((a, b) => a.value - b.value);

    let previousValue: number;
    let positionIndex = 0;
    for (let i = 0; i < valuesArr.length; i++) {
      const { index: dataIndex, value } = valuesArr[i];

      if (value !== previousValue) {
        positionIndex++;
      }
      previousValue = value;
      data[dataIndex].data[dayIndex].y = positionIndex;
    }
  });

  return data as BumpSerie<BumpDatum, Record<string, never>>[];
}
